module.exports = __webpack_public_path__ + "static/media/about-bg-logo.08327ad0.png";